/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { APICodes } from './APICodes';
const BaseErrorParser = /* #__PURE__ */ parsers.object([
    ['message', codecString],
    ['description', codecString],
    ['code', APICodes],
    ['requestId', codecString, 'request_id'],
]);
export class BaseError extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseErrorParser.decode(input).map(res => new BaseError(res));
    }
    static unsafeDecode(input) {
        return BaseError.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseErrorParser.encode(data);
    }
    static schema() {
        return BaseErrorParser.schema();
    }
}
